<div container [classes]="'container--1320'">
  <div
    class="footer d-flex flex-column flex-lg-row-reverse justify-content-lg-between gap-5"
  >
    <div class="footer--top d-flex flex-column justify-content-lg-between">
      <div
        class="footer__social d-flex justify-content-center justify-content-lg-between align-items-center gap-4"
      >
        @for (social of socialLinks; track $index) {
          <a (click)="onClick(social.link, $event)">
            <img
              [src]="'/assets/img/footer/' + social.icon"
              class="img-fluid"
              [alt]="isSpanishPage ? social.alttagEs : social.alttag"
            />
            <!-- <div
            [innerHTML]="sanitize.bypassSecurityTrustHtml(social.icon)"
          ></div> -->
          </a>
        }
      </div>
      <a
        href="https://www.sanofi.us/en"
        target="_blank"
        class="footer__logo d-none d-lg-block text-center"
      >
        <picture
          [data]="{
            image: 'footer/sanofi-logo',
            format: 'png',
            altext: isSpanishPage ? 'Logotipo de Sanofi' : 'Sanofi logo',
            mobile: false,
            webp: false,
            width: '196',
            height: '63',
            classes: 'img-fluid',
          }"
        ></picture>
      </a>
    </div>
    <div class="footer--bottom d-flex flex-column">
      <div
        class="footer__links d-flex flex-column flex-lg-row flex-wrap gap-3 gap-lg-4 text-center text-lg-start"
      >
        @if (!isSpanishPage) {
          @for (
            link of links;
            track link.name;
            let i =
        $index, isLast = $last
          ) {
            <a
              class="text-white fw-bold"
              [attr.href]="link.link"
              [attr.target]="i === 5 ? '_self' : '_blank'"
              target="_blank"
              rel="noopener"
              [innerHTML]="link.name"
            ></a>
          }
        } @else {
          @for (
            link of spanishLinks;
            track link.name;
            let i = $index;
            let isLast = $last
          ) {
            <a
              class="text-white fw-bold"
              [attr.href]="link.link"
              [attr.target]="i === 5 ? '_self' : '_blank'"
              rel="noopener"
              [innerHTML]="link.name"
            ></a>
          }
        }
        <a
          class="text-white fw-bold ot-sdk-show-settings"
          target="_blank"
          rel="noopener"
          id="ot-sdk-btn"
          (click)="onCookieModal()"
          [innerText]="
            isSpanishPage
              ? 'No vender ni compartir mi información personal'
              : 'Do Not Sell or Share My Personal Information'
          "
        >
        </a>
      </div>
      <div class="footer__copy text-center text-lg-start">
        @if (!isSpanishPage) {
          <p class="mb-3">
            Dr. Lauren Crosby, Cara Loren Van Brocklin, Adam Schefter, Cassie
            Bailey, Amanda Smith, Steve Zortman, and Jenny Hoffman
          </p>
          <p class="mb-3">
            Sanofi does not provide medical advice, diagnosis, or
            treatment—information is provided for educational purposes only.
            Your doctor is the best source of health information. Talk to your
            doctor if you have any questions about your health or treatment.
          </p>
          <p class="mb-0">
            © {{ year || defaultYear }} Sanofi. All rights reserved.<br />
            {{ code }}-{{ date || defaultDate }}
          </p>
        } @else {
          <p class="mb-3">
            Dr. Lauren Crosby, Cara Loren Van Brocklin, Adam Schefter, Cassie
            Bailey, Amanda Smith, Steve Zortman, y Jenny Hoffman son portavoces
            remunerados de Sanofi.
          </p>
          <p class="mb-3">
            Sanofi no proporciona consejos, diagnósticos ni tratamientos
            médicos, la información se proporciona únicamente con fines
            educativos. Su médico es la mejor fuente de información sobre su
            salud. Hable con su médico si tiene alguna pregunta sobre su salud o
            tratamiento.
          </p>
          <p class="mb-0">
            © {{ year || defaultYear }} Sanofi. Todos los derechos
            reservados.<br />
            {{ code }}-{{ date || defaultDate }}
          </p>
        }
      </div>
      <a
        href="https://www.sanofi.us/en"
        target="_blank"
        class="footer__logo d-lg-none text-center"
      >
        <picture
          [data]="{
            image: 'footer/sanofi-logo',
            format: 'png',
            altext: isSpanishPage ? 'Logotipo de Sanofi' : 'Sanofi logo',
            mobile: false,
            webp: false,
            fill: false,
            width: '196',
            height: '63',
            classes: 'img-fluid',
          }"
        ></picture>
      </a>
    </div>
  </div>
</div>
